import React from 'react';
// import logo from './logo.svg';
// import './App.css';

// Import the BrowserRouter, Route and Link components
// import { BrowserRouter, Route, Link } from 'react-router-dom'; 

import PageCardd from '../components/PageCardd';

function Test() {
  return (
    <div className="Apps">
        <p>hellow Test</p>
        <p>ghuda</p>
        <div className="row card-details-container">

        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        <PageCardd />
        </div>
    </div>
  );
}

export default Test;
